<template>
	<ja-modal class="confirm-modal add-student-modal" :show="show">
		<ja-close-button
			class="close-button-new-student"
			name="close"
			@click.native="closeModalAddCareer"
		></ja-close-button>

		<div class="modal-content-wrapper">
			<h3 class="title-modal">{{ $t('addNew') + ' ' + $t('career') }}</h3>

			<div class="modal-content">
				<div class="new-user-row">
					<ja-add-career-student-form
						ref="studentForm"
						:facility-id="facilityId"
						@addCareer="updateListObject"
					></ja-add-career-student-form>
				</div>
			</div>
		</div>
	</ja-modal>
</template>

<script>
import '../../icons/expenseCategories';
import '@/components/icons/plus';
import '@/components/icons/info';
import AddCareerStudentForm from '../forms/AddCareerStudentForm';
import Modal from '@/components/Modal/Modal';
import gql from 'graphql-tag';
import CloseButton from '../../ui/CloseButton';

export default {
	components: {
		jaAddCareerStudentForm: AddCareerStudentForm,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	filters: {
		arrayToString(value) {
			return value.join(', ');
		}
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		student: {
			type: Object,
			default: () => {}
		},
		facilityId: {
			type: Number,
			default: null
		}
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		}
	},
	methods: {
		async updateListObject(selectedJob) {
			const career_ID = selectedJob.jobSelection.career_ID || null;

			const careerStudent =
				this.student.career && this.student.career.length > 0
					? this.student.career[0]
					: null;
			const careerStudentID = careerStudent ? careerStudent.id : null;

			const careerInfo = {
				id: careerStudentID,
				userId: this.student.id,
				facility_ID: this.facilityId,
				career_ID: career_ID
			};

			await this.$apollo.mutate({
				mutation: gql`
					mutation($list: [UserCareerInputObjectGraphType]!) {
						addOrUpdateIgnoreNullValuesManyUserCareer(list: $list) {
							id
						}
					}
				`,
				variables: {
					list: [careerInfo]
				}
			});

			this.closeModalAddCareer();
		},
		closeModalAddCareer() {
			this.$emit('closeModalAddCareer');
		}
	}
};
</script>

<style lang="scss" scoped>
.add-student-modal {
	::v-deep .modal {
		min-height: 240px;
		max-height: 768px;
	}

	.page-content {
		flex-grow: 1;
		overflow-y: auto;
		padding: 0 5%;

		::v-deep .modal-wrapper {
			position: fixed;
		}
	}

	.close-button-new-student {
		height: 38px;
		width: 38px;
	}

	.modal-content-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		min-height: 240px;
		max-height: 100%;
		margin: auto;
		overflow: initial;

		.title-modal {
			text-align: center;
			margin-bottom: 8px;
		}

		.import-info,
		.import-result,
		.file-extension-warning {
			text-align: center;
			margin-top: 8px;
			margin-bottom: 8px;

			.import-result-container {
				display: flex;
				justify-content: center;
				.import-result-imported,
				.import-result-failed {
					font-family: 'RobotoMedium';
					color: #00a391;
					margin-bottom: 8px;
					letter-spacing: 0.5px;
					@media (min-width: $breakpoint-mid) {
						font-size: 18px;

						.svg-icon {
							width: 24px;
							height: 24px;
						}
					}
					.svg-icon {
						margin-right: 10px;
					}
				}
				.import-result-failed {
					color: #f93457;
					margin-left: 10px;
				}
			}
			.import-result-failed-messages {
				color: #f93457;
				font-family: 'RobotoMedium';
				margin-bottom: 8px;
				letter-spacing: 0.5px;

				@media (min-width: $breakpoint-mid) {
					font-size: 18px;
				}
			}
		}
		.modal-content {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			width: 100%;
			max-height: 800px;

			.scrollbar {
				max-height: 600px;
			}

			.btn-import {
				margin-left: 16px;
			}
			#file-upload {
				display: none;
			}
		}
	}

	.fields-new-user {
		width: 70%;
		margin: auto;
		display: flex;
		flex-direction: column;
		div.new-user-row:not(:first-child) {
			border-top: 1px solid $button-border;
		}

		.alert-bar-students {
			word-break: break-word;
			border: 1px solid $alert-container-border-color;
			border-radius: 4px;
			padding: 8px;
		}
	}

	.new-user-buttons {
		display: flex;
		width: 100%;
		align-items: center;
		flex-direction: column;
		margin-top: 32px;
		button {
			margin-bottom: 16px;
		}
		.add-another-student {
			margin-top: 16px;
		}
		.error-email {
			color: $error-state;
		}
	}

	.second-row {
		margin-top: 16px;
	}

	::v-deep .alert-message {
		color: $deleteStudentField;
		font-family: 'RobotoRegular';
		font-size: 15px;
		letter-spacing: 0.5px;
		line-height: 23px;
	}

	::v-deep .delete-student-field:first-child {
		display: none;
	}

	::v-deep .alert-message {
		.svg-icon {
			margin-right: 6px;
			margin-top: -3px;
		}
	}

	.btn-done-container {
		display: flex;
		border-top: 1px solid $button-border;

		.btn-done-add-student {
			margin-bottom: -32px;
			margin-left: auto;
			margin-right: auto;
			margin-top: 16px;
			width: 110px;
		}
	}
}
</style>
